import { Component, OnInit } from '@angular/core';
import { UserService } from './modules/userModule/shared/user.service';
import { Router } from '@angular/router';
import { User } from './models/user';
import { HttpService } from './modules/assetModule/shared/services/http.service';
import { HttpClient } from '@angular/common/http';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'VAL';
  timeout:any;
  timeoutSeconds:number;
  constructor(private userService: UserService, private router: Router, private httpService: HttpService, private http: HttpClient) { }
  ngOnInit() {

    // set theme settings
    let User = JSON.parse(sessionStorage.getItem('userinfo'));
    if (User == null) {
      document.documentElement.setAttribute('theme', 'dark');
    }
    else {
      if (User.userSettings.userThemeType == 0) {
        document.documentElement.setAttribute('theme', 'dark')
      } else {
        document.documentElement.setAttribute('theme', 'light');
      }
    }
    this.timeoutSeconds = 7200*1000;
    this.startIdleTimout();
    this.httpService.folderRefresh = true;
    // this.userService.getUser();
    window.onbeforeunload = (ev) => {
    sessionStorage.setItem('folderRefresh', 'true');
    }; 

    if (sessionStorage.getItem('userinfo')) {
      this.userService.loggendInUser = JSON.parse(sessionStorage.getItem('userinfo'));
      this.httpService.changeThemeFlag(this.userService.loggendInUser.userSettings.userThemeType===0?'dark':'light');
    }
    // else {
    //   this.userService.loginUser().subscribe(
    //     data => {
    //       let response: any = data;
    //       this.userService.loggendInUser = response.userDetails as User;
    //       sessionStorage.setItem("userinfo", JSON.stringify(this.userService.loggendInUser));
    //     },
    //     error => {
    //       console.log(error);
    //     }
    //   )
    // }
  }
  startIdleTimout()
  {
    window.addEventListener("mousedown",()=>{this.resetIdleTimeout(this.timeout)});
    window.addEventListener("mousemove",()=>{this.resetIdleTimeout(this.timeout)});
    window.addEventListener("mousewheel",()=>{this.resetIdleTimeout(this.timeout)});
    window.addEventListener("keydown",()=>{this.resetIdleTimeout(this.timeout)});
    this.timeout = window.setTimeout(this.redirectToLogout,this.timeoutSeconds);
  }
  resetIdleTimeout(handler)
  {
    clearTimeout(handler);
    this.timeout = window.setTimeout(this.redirectToLogout,this.timeoutSeconds);
  }
  redirectToLogout()
  {
    sessionStorage.setItem('folderRefresh', 'true');
    window.open(environment.logoutUrl,'_self');
  }
}
